 <!--
    2019-2-13, AJK, created file
    2019-3-6, AJK, added ability to reset password
    2019-3-6, AJK, updated to use snotify
 -->

<template>
  <div class="login-page container">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <div class="columns is-centered">
      <div id="card" class="column card-container is-full">
        
        <b-tabs size="is-large" class="block" @input="loadRepeatedData">
            <b-tab-item label="Past Orders"></b-tab-item>
            <!-- <b-tab-item label="Repeated Orders"></b-tab-item> -->
        </b-tabs>
        <p v-if="!this.orders.length">There seems to be nothing here!</p>
        <div v-if="this.orders.length" class="row is-centered">
            <b-table :data="orders"
              hoverable
              default-sort-direction="asc"
              default-sort="date"
              @click="(row, index) => navigate(row.recordID)">
              <template slot-scope="props">
            
                <b-table-column field="orderNumber" label="Order Number">
                  <strong>{{ props.row.orderNumber}}</strong>
                </b-table-column>        
                
                <b-table-column field="date" label="Date" sortable :custom-sort="sortByDate">
                  {{ new Date(props.row.date).toLocaleDateString() }}
                </b-table-column> 
                
                <b-table-column field="trackingNumber" label="Tracking Number">
                  {{ props.row.trackingNumber }}
                </b-table-column>

                <b-table-column field="nextRepeatDate" label="Repeat Date" sortable>
                  {{ props.row.nextRepeatDate }}
                </b-table-column>
                
                <b-table-column field="total" label="Total">
                  {{ props.row.zcnGrandTotal | currency}}
                </b-table-column>

                <b-table-column field="RepeatButton"  numeric>
                    <b-button class="button is-primary is-pulled-right navChevron" icon-right="chevron-right"/>
                    <button v-on:click.stop.prevent="repeatOrder(props.row.__kptID)" type="email" placeholder="email" class="button is-primary is-pulled-right">Reorder</button>

                </b-table-column>
              </template>
            </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loginAPI from '@/api/LoginAPI.js'
import sharedAPI from '@/api/SharedAPI.js'
import store from '../store.js'
import { mapMutations, mapState } from 'vuex'
import axios from 'axios'

export default {
    name: 'Dashboard',
    props: ['usernameProp'],
    data () {
        return {
            isDefaultTab: true,
            isRepeatedTab: false,
            username: null,
            password: null,
            hash: null,
            errorMsg: null,
            isLoading: false,
            isFullPage: true,
            notificationDuration: 4000,
            orders: []
        }
    },

    filters: {
      currency: function(price){
        if (price){
          return "$".concat(price.toFixed(2));
        }else{
          return ""
        }

      }
    },

    mounted(){
        this.loadData()
    },

    computed:{
    ...mapState([
      'userInfo','cart'
      ])
    },

    created() {
        if( this.usernameProp ){
            this.username = this.usernameProp;
        }
        //Allow email and hash to be passed via query params.
        var hash = this.$route.query.hash;
        var email = this.$route.query.email;
        if( hash !== undefined){
            this.hash = hash;
            this.password = hash;
            this.username = email;
        }
    },
    
    methods: {
        ...mapMutations([
          'setCampaigns', 
          'setEmails',
          'setCampaignsAndEmails',
          'setSelectedCampaign',
          'setCart'
        ]),
        repeatOrder: function(orderID){
          var self = this;
          axios.post (`proxy.php?/layouts/order-request-line-item-lookup/_find`, 
          {query: [
            { 
            _kftOrderRequestID : '=' + orderID }
            ]
          }
          )
          .then(response=>{
            var parse = response.data.response.data;

            //check if line items can be reordered
            var inelligible = []
            parse.forEach (function (element) {
              if (element.fieldData.zcnCanBeReordered != 1  ){
                inelligible.push(element.fieldData.productName)
              }
            });

            //create message for inelligible items
            if (inelligible.length > 0){
              var e
              if (inelligible.length > 1){
                inelligible[inelligible.length-1] = "and " + inelligible[inelligible.length-1]
                e = inelligible.join(", ")
                e = "Items " + e + " are not available to be ordered."
              }else{
                e = inelligible[0] + " is not available to be ordered."
              }
              self.$root.$children[0].$refs.toast.error(e, "Unavailable", {pauseOnHover: true, closeOnClick: true})
              return
            }

            //kill cart
            self.cart.products.splice(0, self.cart.products.length)
            //add elligible items to cart
            var count = 0
            parse.forEach (function (element) {
              if (element.fieldData.zcnCanBeReordered == 1 ){
                var cartItem = {
                  __kptID: element.fieldData._kftProductID,
                  price: element.fieldData.price,
                  productName: element.fieldData.productName,
                  quantity: element.fieldData.qty,
                  isCustomBlend: false
                }
                self.cart.products.push(cartItem);
                count = count + 1
              }
            });
            if(count>0){
              var message = " product added to cart."
              if (count > 1){
                message = " products added to cart."
              }
              message = count + message
              self.setCart(self.cart)
              self.$root.$children[0].$refs.toast.success(message, "Prepared Cart!")
              self.$router.replace({ name: 'cart'})
            }
            
          }).catch(error=>{
            console.log(error)
          })
        },

        navigate: function (orderNumber) {
            // console.log(orderNumber)
            this.$router.replace({ name: 'orderDetail', params:{ id: orderNumber}})
        },

        loadData: function() {
        var self = this;
        return axios.post (`proxy.php?/layouts/order-request-lookup/_find`, 
          {query: [
            { 
            _kftWholesalerID : '=' + self.userInfo.userID ,
            isCancelled : '=' + "=" }
            ],
            sort: [
               {
                 "fieldName": 'date',
                 "sortOrder": 'descend'
               }
            ],           
            limit: 500,
          }
        )
          .then(response=>{
            // console.log(response)
            var parse = response.data.response.data;
            
            parse.forEach (function (element) {
              self.orders.push(element.fieldData);
            });
          }).catch(error=>{
            console.log(error)
          })

        },

        loadRepeatedData: function(param) {
        var self = this;
        // console.log(param)
        if (param == 0){
            //tab panel at index 0 -- past orders
            self.isDefaultTab = true;
            self.isRepeatedTab = false;
            var query = {query: [
              { 
                _kftWholesalerID : '=' + self.userInfo.userID ,
                isCancelled : '=' + "=",
              }
            ] 
          }
        }
        else if (param == 1){
            //tab panel at index 1 -- repeated orders
            self.isDefaultTab = false;
            self.isRepeatedTab = true;
            var query = {query: [
              { 
                _kftWholesalerID : '=' + self.userInfo.userID ,
                isCancelled : '=' + "=",
                isRepeatedOrder: '=' + 1
              }
            ] 
          }
        }
        else{
          return
        }
        self.orders.splice(0, self.orders.length)

        return axios.post (`proxy.php?/layouts/order-request-lookup/_find`, query)
          .then(response=>{
            // console.log(response)
            var parse = response.data.response.data;
            
            parse.forEach (function (element) {
              self.orders.push(element.fieldData);
            });
            
          }).catch(error=>{
            console.log(error)
          })
        },

        sortByDate(a, b, isAsc) {
          if (isAsc) {
            return new Date(b.date).getTime() - new Date(a.date).getTime();
          } else {
            return new Date(a.date).getTime() - new Date(b.date).getTime();
          }
        },
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
  .navChevron{
    margin-left: 20px
  }

    .has-text-danger {
        padding-bottom: 20px;
    }
    .center {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    .card-container {
    padding: 2rem;
    margin: 0px 20px 20px 20px;
  } 
  /*.field-container {*/
  /*  background-color: #FFFFFF;*/
  /*  border: solid 1px #cccccc;*/
  /*  border-radius: 5px;*/
  /*  padding: 2rem;*/
  /*  margin: 0px 20px 20px 20px;*/
  /*}  */
</style>
